<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
    <!-- Teamio Agent — unified panel replacing the old TeamIOBotWidget -->
    <AgentSidebar v-if="showAgentPanel" title="Teamio Agent" :agentUrl="agentUrl" :apiKey="agentApiKey" :siteId="siteId" />
  </div>
</template>

<script>
import AgentSidebar from '@/components/AgentPanel/AgentSidebar.vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    AgentSidebar,
  },
  created() {
    //console.log(`i am in App created`);
    const currentPath = this.$router.history.current.path;
    //console.log(currentPath);

    let onViewFormPage = currentPath.startsWith('/view-form');
    //console.log('i am on view-form page');

    if (window.localStorage.getItem('authenticated') === 'false' && !onViewFormPage) {
      //console.log(`i am in App.vue. Now redirecting to login`);
      this.$router.push('/login');
    }

    if (currentPath === '/' || currentPath === '/app') {
      //console.log('in app.vue, redirecting to /app');
      this.$router.push('/app/');
    }

    // PHASE 2 PREVENTION: Start periodic cleanup for expired follow-up sessions
    this.startPeriodicCleanup();
  },

  // PHASE 2 PREVENTION: Add beforeDestroy for cleanup
  beforeDestroy() {
    this.stopPeriodicCleanup();
  },

  // PHASE 2 PREVENTION: Vue 3 compatibility
  beforeUnmount() {
    this.stopPeriodicCleanup();
  },

  data() {
    return {
      // PHASE 2 PREVENTION: Track cleanup interval
      cleanupInterval: null
    }
  },

  computed: {
    ...mapState({
      user: state => state.customer.user,
      siteId: state => state.customer.siteID,
      settings: state => state.customer.settings,
    }),
    showAgentPanel() {
      // Render the panel for every authenticated user. The component itself
      // decides what's visible inside based on the user's role:
      //   - Super Admin: full Teamio Agent (chat + AI Call modal + Action Center)
      //   - everyone else: Action Center only (AI chat hidden)
      if (this.$route.meta.requiresAuth === false) return false;
      return !!this.user;
    },
    agentUrl() {
      return process.env.VUE_APP_AGENT_URL || '';
    },
    agentApiKey() {
      return process.env.VUE_APP_AGENT_BEARER_TOKEN || '';
    },
  },

  methods: {
    // Start periodic cleanup of expired sessions
    startPeriodicCleanup() {
      // Run cleanup every 5 minutes
      this.cleanupInterval = setInterval(async () => {
        try {
          if (this.$store.state.cache) {
            await this.$store.dispatch('cache/cleanupExpiredSessions');
          }
        } catch (error) {
          console.error('[FOLLOWUP] Error during periodic cleanup:', error);
        }
      }, 5 * 60 * 1000); // 5 minutes
    },

    // Stop periodic cleanup
    stopPeriodicCleanup() {
      if (this.cleanupInterval) {
        clearInterval(this.cleanupInterval);
        this.cleanupInterval = null;
      }
    }
  }
};
</script>

<style src="./styles/theme.scss" lang="scss" />

<style scoped>
/* Make the app wrapper transparent to layout - don't interfere with child components */
#app {
  height: 100%;
  width: 100%;
  position: relative;
  /* Ensure this doesn't add any margins, padding, or layout constraints */
  margin: 0;
  padding: 0;
  border: none;
  /* Allow child components to control their own layout completely */
  display: contents;
}

/* Fallback for browsers that don't support display: contents */
@supports not (display: contents) {
  #app {
    display: block;
    height: 100vh;
    width: 100vw;
  }
}
</style>
